module.exports = __webpack_public_path__ + "img/multiple-choice.ee4dc61a.svg";